import {AlertController, Platform} from 'ionic-angular';
import {Injectable} from '@angular/core';
import {Dialogs} from '@ionic-native/dialogs';
import {SpinnerDialog} from '@ionic-native/spinner-dialog';

/*
  Generated class for the AlertProvider provider.

  See https://angular.io/docs/ts/latest/guide/dependency-injection.html
  for more info on providers and Angular DI.
*/
@Injectable()
export class AlertProvider {

  private active: boolean = false;
  private alert: any;

  constructor(
    private platform: Platform,
    private dialogs: Dialogs,
    private alertCtrl: AlertController,
    private spinnerDialog: SpinnerDialog,
  ) {
    // console.log('Hello AlertProvider Provider');
  }

  doInfoAlert(message: string) {
    this.doAlert(message, 'Informe');
  }

  doAlert(message: string, title: string = null, onClose: any = null, buttonText: string = 'OK') {
    let that = this;

    if (title === null) {
      title = 'Aviso';
    }

    if (!this.active) {
      this.active = true;

      // DONE: Fix error cordova_not_available
      if (this.platform.is('cordova')) {
        this.dialogs.alert(message, title)
          .then(() => {
            that.active = false;

            if (onClose) {
              onClose();
            }
          });
      } else {
        this.alert = this.alertCtrl.create({
          title: title,
          subTitle: message,
          buttons: [
            {
              text: buttonText,
              role: 'cancel',
              handler: () => {
                that.active = false;

                if (onClose) {
                  onClose();
                }
              }
            }
          ],
          enableBackdropDismiss: false
        });
        this.alert.present();
      }
    }
  }

  doConfirm(message: string, agree: any, disagree: any = null, agreeLabel: string = 'Sim', disagreeLabel: string = 'Não', title: string = null, customCss: any = null): void {
    let that = this;

    if (!this.active) {
      this.active = true;

      // DONE: Fix error cordova_not_available
      if (this.platform.is('cordova')) {
        this.dialogs.confirm(message, 'Confirmação', [agreeLabel, disagreeLabel])
          .then((idx: number): void => {
            that.active = false;

            if ((idx === 1) && (agree !== null)) {
              agree();
            } else if ((idx === 2) && (disagree !== null)) {
              disagree();
            }
          })
          .catch(e => console.log('Error displaying dialog', e));
      } else {
        this.alert = this.alertCtrl.create({
          title: title || 'Confirmação',
          message: message,
          buttons: [
            {
              text: disagreeLabel || 'Não',
              role: 'cancel',
              handler: (): void => {
                that.active = false;

                if (disagree !== null) {
                  disagree();
                }
              }
            },
            {
              text: agreeLabel || 'Sim',
              handler: (): void => {
                that.active = false;

                if (agree !== null) {
                  agree();
                }
              }
            }
          ],
          enableBackdropDismiss: false,
          cssClass: customCss
        });
        this.alert.present();
      }
    }
  }

  doWaiting(message: string): void {
    this.spinnerDialog.show('Aguarde', message, true);
  }

  doWaitingHide(): void {
    this.spinnerDialog.hide();
  }

}



// WEBPACK FOOTER //
// ./src/providers/alert/alert.ts